import React from 'react';
import v from 'vudu';
import { styles as s, format as f, classes as c, colors } from 'stylesheet';
import Text from 'components/Text';
import aspectRatio from 'utils/aspectRatio';
import get from 'utils/get';
import SegmentWrapper from 'lib/segment';

const localClasses = v({
  mobileGearSubset: {
    '@composes': [s.pt5, s.pb6],
    maxWidth: '500px',
    margin: 'auto'
  },
  subsetCopy: {
    '@composes': [s.center]
  },
  gearImage: {
    position: 'relative',
    maxWidth: '100%',
    maxHeight: '100%',
    bottom: '0'
  },
  gearImageBacking: aspectRatio(1, 1)({
    borderRadius: '50%',
    perspective: '20px',
    backgroundImage: 'linear-gradient(131deg, rgba(127, 1, 93, 0.4) 0%, rgba(52, 26, 110, 0.4) 100%)'
  }),
  shortName: {
    marginBottom: '-40px',
    whiteSpace: 'nowrap',
    fontSize: '56px'
  },
  itemHeader: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
});

const MobileGearItem = props => (
  <div className={f(c.clearfix, c.pb5)}>
    <Text variant={'gearBacking'} classes={f(localClasses.shortName, c.center)}>{props.item.shortName}</Text>
    <div className={f(localClasses.gearImageBacking, c.col10, c.mxAuto)}>
      <div className={f('content', c.center)}>
        <img className={localClasses.gearImage} src={props.item.image} alt={props.item.title} />
      </div>
    </div>

    <div className={localClasses.itemHeader}>
      <div>
        <Text variant={'smallTracked'} color={'razzmatazz'}>Retail Price</Text>
      </div>
      <div>
        <Text variant={'largeness'}>{`$${props.item.price}`}</Text>
      </div>
    </div>

    <div className={f(c.col12, c.left)}>
      <Text variant={'pBook'} classes={f(c.pb1)} color={'pinkSlate'}>{props.item.description}</Text>
    </div>
    <div className={f(c.col12, c.left)} onClick={() => window.open(props.item.url) && SegmentWrapper.didClickLearnMore(props.item.name)}>
      <Text variant={'pBold'} color={'byzantine'}>Learn More</Text>
    </div>

  </div>
);

export default props => (
  <div className={f(localClasses.mobileGearSubset)}>
    <div className={f(c.row, c.clearfix, c.pb3)}>
      <div className={localClasses.subsetCopy}>
        <Text variant={'heavyHeadline'}>{props.set.title}</Text>
        <Text variant={'p'}>{props.set.description}</Text>
      </div>
    </div>
    <div className={f(c.row, c.clearfix)}>
      {get(props, 'set.items', []).map((item, i) => <MobileGearItem item={item} key={i} />)}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/MobileGearSubset.js